import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidAddSectionMutationData, IValidRemoveSectionMutationData } from '../base/valid-mutation-data';

export class AddSectionMutation extends BaseMutation<PresentationDataModel, IValidAddSectionMutationData> {
    public readonly type: MutationType = MutationType.AddSection;

    public apply(presentation: PresentationDataModel) {
        const { sectionId, name } = this.data;
        presentation.store.addSection({ id: sectionId, name, numSlides: 0 });
    }

    public invert(): [IValidRemoveSectionMutationData] {
        return [
            {
                type: MutationType.RemoveSection,
                sectionId: this.data.sectionId,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { sectionId } = this.data;
        return Rule.model.should.notExist(presentation, sectionId);
    }
}
